module.exports = __webpack_public_path__ + "resource/img/image027Dark.9f35717b.png";